import { isServer } from './dom';

const ua = !isServer && navigator.userAgent.toLowerCase();
export const isWin = ua && /windows/.test(ua);
export const isIPad = ua && /ipad/.test(ua) && 'ontouchend' in document;
export const isIPhone = ua && !isIPad && /(iphone|ipod)/.test(ua);
export const isMac = ua && !isIPad && !isIPhone && /macintosh/.test(ua);
export const isAndroid = ua && ua.indexOf('android') > 0;
export const isMobie = isIPhone || isAndroid || isIPad;

export const isLinux = ua && !isAndroid && /linux (i686|x86_64)/.test(ua);
export const isChromeOS = ua && /cros/.test(ua);

export const isFirefox = ua && /firefox/.test(ua);
export const isOpera = ua && /opera|opr\/[\d]+/.test(ua);
export const isIE = ua && !isOpera && /(msie|trident)/.test(ua);
export const isIELower = ua && ua.indexOf('compatible') > -1 && ua.indexOf('msie') > -1; // IE < 11
export const isEdge = ua && /edge\/(\d+)/.test(ua); // MS spartan browser
export const isChrome = ua && !isOpera && !isEdge && /chrome/.test(ua) && /webkit/.test(ua);
export const isSafari = (!isServer && window.__isSafari__) || (ua && !isOpera && !isEdge && !isChrome && /safari/.test(ua));
export const isIE8 = ua && isIE && /(msie 8)/.test(ua);
export const isBrowser64 = ua && /x64|win64|amd64|x86_64/.test(ua);
export const weSnsType = ua && window.weSnsType === 100;
